<template>
  <div class="datepicker mb-xl">
    <v-date-picker
      mode="range"
      v-model="date"
      :value="null"
      color="blue"
      is-inline
      is-expanded
      :attributes="attributes"
    />
    <transition name="fade-delayed" appear>
      <span
        class="picker-label text--xs"
        v-if="!date.start"
        v-text="localize('choose_dates')"
      ></span>
      <a v-else class="clear text--xs" @click.prevent="cleardates" href="#p">
        <i class="fas fa-times"></i>
        <span>CLEAR DATES</span>
      </a>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
// import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  props: {
    children: Array,
    title: String,

    /*
      Object in Vuex state where date should
      be inserted
    */
    state: {
      type: String,
      default: null
    },
    /*
      The property indentifier in the state object
      the date should be inserted.
    */
    identifier: {
      type: String,
      default: null
    }
  },
  components: {
    "v-date-picker": () => import("v-calendar/lib/components/date-picker.umd")
  },
  data() {
    return {
      date: { start: null, end: null }
      // attributes: [
      //   {
      //     key: "today",
      //     dot: true,
      //     popover: { label: "hello" },
      //     dates: new Date()
      //   }
      // ]
    };
  },
  watch: {
    date() {
      console.log("date changed...", this.date);
      this.updateDate(this.date);
    }
  },
  methods: {
    ...mapActions(["updateDate"]),
    cleardates() {
      this.$set(this, "date", { start: null, end: null });
    }
  },
  computed: {
    ...mapState({
      attributes: state => state.events.attributes
    })
  }
};
</script>

<style lang="stylus" scoped>
.vc-container
  border 0
  border-bottom 1px solid rgba(33,33,33,0.2)
  border-radius 0
  padding-bottom 3px
  z-index 12
.datepicker
  position relative
.picker-label
.clear
  position relative
  display block
  color gray_6
  cursor pointer
  z-index 12
  padding 3px 0 5px
  border-bottom 1px solid rgba(33,33,33,0.2)
  span
    margin-left 3px
.clear
  text-transform uppercase
.picker-label
  width 100%
  text-align center
  color gray_9
  cursor default
+desktop()
  .clear
    &:hover
      color gray_9
// .datepicker
//   background rgba(red,0.1)
>>> .vc-popover-content-wrapper
  z-index 9999999
  position fixed
  max-width 200px
  // min-width 220px
  .vc-popover-content
    padding 8px 4px 4px
    max-width 100%
    _flex(column, wrap, center, center)
    & > *
      max-width 100%
  .vc-day-popover-row
    max-width 100%
    margin 0 auto 3px !important
  .vc-text-center
    margin 0 auto 8px !important
    font-weight 400 !important
  .vc-day-popover-row-content
    align-items flex-start
    max-width 96%
    line-height 1.1
  .vc-day-popover-row-indicator
    width 6px
    margin 4px 4px
</style>
